import {FlexPage} from '@hconnect/common/components'
import {Grid, useMediaQuery, useTheme} from '@mui/material'

type LayoutProps = {
  titleSlot?: React.ReactNode
  systemChangeRequestsSlot?: React.ReactNode
  systemJobsToBeDoneSlot?: React.ReactNode
  systemUptimeSlot?: React.ReactNode
}

export const SystemsEngineerDashboardLayout = ({
  titleSlot,
  systemChangeRequestsSlot,
  systemJobsToBeDoneSlot,
  systemUptimeSlot
}: LayoutProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const spacing = isMobile ? 1 : 2

  return (
    <FlexPage
      title={titleSlot}
      nameHeaderSx={{mt: titleSlot ? 0 : undefined}}
      useViewportHeight={!isMobile}
    >
      <Grid container spacing={spacing} flex={1} maxHeight={isMobile ? undefined : '100%'}>
        <Grid item xs={12} sm={6} xl={4} maxHeight={isMobile ? undefined : '100%'}>
          {systemChangeRequestsSlot}
        </Grid>
        <Grid item container xs={12} sm={6} xl={8} spacing={spacing}>
          <Grid item xs={12} sm={12} xl={6}>
            {systemJobsToBeDoneSlot}
          </Grid>
          <Grid item xs={12} sm={12} xl={6}>
            {systemUptimeSlot}
          </Grid>
        </Grid>
      </Grid>
    </FlexPage>
  )
}
